import { BooleanInput, SearchInput } from 'react-admin'

const PersonalizationRuleListFilter = [
    <SearchInput variant="outlined" placeholder="Search label" source="label" alwaysOn />,
    <BooleanInput source="active" label="Published" variant="outlined" defaultValue={true} />
]

export default PersonalizationRuleListFilter
